var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="" data-menuregion="editIncludeExcludeMode">\n	<div title="In diesem Modus können Sie eine eigene, unabhängige Auswahl auf einzelne Einträge machen (Whitelist/Blacklist).">\n		<div class="MenuItem" data-favcustomizeview="enter">\n			<div class="MenuInline MenuIcon">\n				<i class="fa fa-plus-circle '+
((__t=( hasData.include ))==null?'':__t)+
'"></i>\n				<i class="fa fa-minus-circle '+
((__t=( hasData.exclude ))==null?'':__t)+
'"></i>\n			</div>\n			<div class="MenuLabel MenuInline '+
((__t=( hasData.includeExclude ))==null?'':__t)+
'">Einzeln hinzufügen/entfernen</div>\n		</div>\n	</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));
